import React from "react";
import { ImageURL } from "../../component/config/config";

const DishDetailsContent = ({ dishDetails, dishesSold = 0, actions }) => {
  const ingredients = Array.isArray(dishDetails?.ingredientResult)
    ? dishDetails.ingredientResult
    : [];

  return (
    <div className="dash-bottom mt-2 order-detail dish-details-content">
      <div className="col-md-6 dish-details-main">
        <figure>
          <img
            src={ImageURL + (dishDetails?.dishImage || "")}
            alt={dishDetails?.name || "Dish"}
          />
        </figure>
        <span>
          {dishDetails?.menuStatus ? (
            <span className="text-info purple-bg">On Menu</span>
          ) : (
            <span className="text-info pink-bg">Not on Menu</span>
          )}
        </span>
        <h4 className="title-inner">
          {dishDetails?.name}
          <span className="dish-details-sold-count">Dishes Sold: {dishesSold}</span>
        </h4>
        <small className="price-text">
          ${Number(dishDetails?.price || 0).toFixed(2)}
        </small>
        <span className="text-food">{dishDetails?.cuisineName}</span>
        <div className="food-info">
          <span>
            <b>Food Type:</b> {dishDetails?.categoryName}
          </span>
          <span>
            <b>Portion Size:</b>{" "}
            {dishDetails?.portionSizeCount > 0
              ? `${dishDetails?.portionSize} - ${dishDetails?.portionSizeCount}`
              : dishDetails?.portionSize}
          </span>
          <br />
          <span className="dish-details-description">{dishDetails?.description}</span>
        </div>
      </div>

      <hr className="grey-line" />

      <div className="food-info food-info-break col-md-6">
        <span>
          <b>Dietary Tags </b>
          {Array.isArray(dishDetails?.restrictedDiets)
            ? dishDetails.restrictedDiets.join(", ")
            : dishDetails?.restrictedDiets}
        </span>
        <span>
          <b>Preparation Time:</b>
          {`${dishDetails?.preprationTime || ""}${
            Number(dishDetails?.preprationTime) <= 1 ? "min" : "mins"
          }`}
        </span>
        <span>
          <b>Ingredients:</b>
          {ingredients.map((ingredient, index) => (
            <React.Fragment key={ingredient?._id || `${ingredient?.name}-${index}`}>
              {index === ingredients.length - 1
                ? ingredient?.name
                : `${ingredient?.name}, `}
            </React.Fragment>
          ))}
        </span>
      </div>

      {actions ? <div className="mt-4 btn-group">{actions}</div> : null}
    </div>
  );
};

export default DishDetailsContent;
